export default "__VITE_ASSET__CiA1KTeo__"